import { useState, useEffect, useContext, useMemo } from 'react';
import { getRequest } from '../api/ApiController';
import { DatabaseContext } from '../redux/DatabaseStore';

function trainingCompanyFilter(company, includeExcluded) {
  const types = company?.types;
  const hasTraining = Array.isArray(types)
    ? types.includes('training_company')
    : (typeof types === 'string' && (types.includes('training_company') || types.includes('"training_company"')));
  if (!hasTraining) return false;
  if (includeExcluded) return true;
  const v = company?.validity;
  return v === '1' || v === 1;
}

/**
 * Zoznam školiacich firiem: ak sú v state z loginu (state.companies), používa ich bez volania API; inak načíta z API.
 * @param {Object} [options]
 * @param {boolean} [options.includeExcluded=false] – true = vrátí aj vyradené firmy (pre edit formuláre)
 * @returns {{ trainingCompanies: Array, loading: boolean }}
 */
export function useTrainingCompanies(options = {}) {
  const { includeExcluded = false } = options;
  const [state] = useContext(DatabaseContext);
  const [fallbackList, setFallbackList] = useState([]);
  const [fallbackLoading, setFallbackLoading] = useState(false);

  const fromState = useMemo(() => {
    const list = state?.companies ?? [];
    if (!Array.isArray(list) || list.length === 0) return null;
    const filtered = list
      .filter((c) => trainingCompanyFilter(c, includeExcluded))
      .map((c) => ({ id: c.id, name: c.name }));
    return filtered.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  }, [state?.companies, includeExcluded]);

  useEffect(() => {
    if (fromState != null) return;
    setFallbackLoading(true);
    const params = new URLSearchParams({ minimal: '1', type: 'training' });
    if (includeExcluded) params.set('include_excluded', '1');
    getRequest(`/api/companies?${params.toString()}`)
      .then((r) => {
        const list = r?.data ?? [];
        setFallbackList(Array.isArray(list) ? list : []);
      })
      .catch(() => setFallbackList([]))
      .finally(() => setFallbackLoading(false));
  }, [includeExcluded, fromState]);

  const trainingCompanies = fromState ?? fallbackList;
  const loading = fromState != null ? false : fallbackLoading;

  return { trainingCompanies, loading };
}
